import { render, staticRenderFns } from "./OrderFormStripePaymentMethodForm.vue?vue&type=template&id=b87fc088"
import script from "./OrderFormStripePaymentMethodForm.vue?vue&type=script&lang=js"
export * from "./OrderFormStripePaymentMethodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports